module.exports = __webpack_public_path__ + "static/media/group4050@2x.19a89ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4050@2x.png
// module id = 582
// module chunks = 1